export * from './dom-only-props'



/** WEBPACK FOOTER **
 ** ./src/utils/dom-only-props/index.js
 **/